module.exports = __webpack_public_path__ + "static/headshot-michael-lynn.895e2d85.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/headshot-michael-lynn.jpg
// module id = 527
// module chunks = 152909308826437